import styled from "styled-components";

import { BackgroundFeedPageImageContainer } from "pages/[tenant]/feed/components/atoms/BackgroundFeedPageImage/styles";
import { FeedPostContainerContainer } from "pages/[tenant]/feed/components/atoms/FeedPostContainer/styles";
import { FeedPostUserContainer } from "pages/[tenant]/feed/components/atoms/FeedPostUser/styles";
import { FeedPostDetailsContainer } from "pages/[tenant]/feed/components/molecules/FeedPostDetails/styles";
import { KeepWatchingMobileSlidesContainer } from "pages/[tenant]/feed/components/molecules/KeepWatchingMobileSlides/styles";
import { OnlineRecentlyContainer } from "pages/[tenant]/feed/components/molecules/OnlineRecently/styles";
import { feedPageBreakpoints } from "pages/[tenant]/feed/utils/feedPageBreakpoints";

import { CropImageModal } from "shared/components/organisms/CropImage/styles";

export const FeedPageContainer = styled.div`
  height: 100%;

  margin: 5rem auto 0 auto;

  display: grid;
  grid-template-areas: "content";
  align-items: start;

  background-color: ${({ theme }) =>
    theme.mode === "dark" ? "#000" : "#F6F6FCCC"};

  ${BackgroundFeedPageImageContainer}, > .content {
    grid-area: content;
  }

  @media (max-width: 990px) {
    margin-top: 1rem;
  }

  > .content {
    max-width: 1500px;
    padding: 1rem;
    width: 100%;

    display: grid;
    grid-template-areas: "user-data posts aditional-content";
    grid-template-columns: minmax(200px, 310px) minmax(0, 800px) minmax(
        200px,
        350px
      );
    gap: 2rem;

    margin: 2rem auto 0 auto;

    @media (max-width: ${feedPageBreakpoints?.hd}px) {
      grid-template-columns: 310px minmax(0, 800px);
      grid-template-areas: "user-data posts";

      .aditional-content {
        display: none;
      }
    }

    @media (max-width: ${feedPageBreakpoints?.mobile}px) {
      grid-template-columns: 1fr;
      grid-template-areas: "posts";

      .user-data {
        display: none;
      }

      ${FeedPostContainerContainer} {
        grid-template-columns: 1fr auto;
      }

      ${FeedPostUserContainer} {
        > div,
        .texts {
          width: 100%;
        }

        .user-info {
          justify-content: space-between;
        }

        .created-at {
          display: flex;
          align-items: center;
        }
      }
    }
  }

  .user-data {
    grid-area: user-data;
    z-index: 3;

    overflow-y: scroll;
    max-height: 86vh;

    &::-webkit-scrollbar {
      display: none;
    }

    &::-webkit-scrollbar-track {
      display: none;
    }

    &::-webkit-scrollbar-thumb {
      display: none;
    }
  }

  .posts {
    grid-area: posts;
    z-index: 2;

    :has(${FeedPostDetailsContainer}) {
      ${KeepWatchingMobileSlidesContainer}, ${OnlineRecentlyContainer} {
        display: none;
      }
    }

    :has(${CropImageModal}) {
      z-index: 999999;

      ${CropImageModal} {
        top: 0;
      }
    }
  }

  .aditional-content {
    grid-area: aditional-content;
  }

  .user-data,
  .aditional-content {
    position: sticky;
    top: 6rem;
    height: fit-content;

    display: flex;
    flex-direction: column;
    gap: 24px;

    @media (max-width: 990px) {
      top: 2rem;
    }
  }
`;
